<template>
  <div class="code-page">
    <section class="code-page-header">
      <p class="page-title">输入验证码</p>
      <p class="note">您正在进行注销账户的操作，为保护账号安全，已将手机验证码发送至{{ showTel }}</p>
    </section>

    <section class="code-page-input">
      <van-field
        v-model="verifyCode"
        :maxlength="4"
        type="number"
        label=" "
        label-width="0"
        placeholder="请输入验证码"
      />
      <div class="get-code-btn">
        <span v-if="!isPostVerifyCode" v-reClick="getVerifyCode">获取短信验证码</span>
        <span class="disabledSpan" v-else-if="isPostVerifyCode && count">{{ count }}s后重新获取短信验证码</span>
        <span v-else v-reClick="getVerifyCode">重新获取短信验证码</span>
      </div>
    </section>

    <section class="code-page-input">
      <van-button
        :disabled="disabledConfirm"
        style="width: 100%"
        type="primary"
        round
        size="normal"
        @click="confirmVerifyCode"
      >
        确定
      </van-button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      verifyCode: '',
      showTel: '',
      tel: '',
      isPostVerifyCode: false,
      count: 60,
      timer: null,
      verifyCodeType: 'LOG_OFF_ACCOUNT'
    };
  },
  computed: {
    disabledConfirm() {
      if (this.verifyCode && this.verifyCode.toString().length >= 4) {
        return false;
      }
      return true;
    }
  },
  created() {
    const { tel = '' } = this.$route.query;
    this.showTel = tel.substr(0, 3) + '****' + tel.substr(7);
    this.tel = tel;
  },
  methods: {
    getVerifyCode() {
      const params = {
        mobile: this.tel,
        verifyCodeType: this.verifyCodeType
      };
      this.$fetch.getMobileCode(params).then(() => {
        this.precessCountTime();
        this.isPostVerifyCode = true;
        this.$toast(`已发送验证码到手机 ${this.showTel}，请查收`);
      });
    },
    confirmVerifyCode() {
      this.$fetch
        .logOffAccount({
          mobile: this.tel,
          verifyCode: this.verifyCode,
          verifyCodeType: this.verifyCodeType
        })
        .then(() => {
          this.$router.push({
            name: 'logOffSuccess'
          });
        });
    },
    precessCountTime() {
      this.count = 60;
      this.timer = null;
      this.timer = setInterval(() => {
        this.count--;
        if (this.count === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
.code-page {
  height: 100%;
  padding: 44px 40px 0;
  background: #ffffff;
  &-header {
    margin-bottom: 32px;
    .page-title {
      color: #262626;
      font-size: 24px;
      margin-bottom: 8px;
    }
    .note {
      color: #8c8c8c;
      font-size: 14px;
      line-height: 21px;
    }
  }
  &-input {
    margin-bottom: 40px;
    .get-code-btn {
      margin-top: 32px;
      font-size: 14px;
      color: #1e8dff;
      text-align: right;
      span {
        padding: 4px;
        &.disabledSpan {
          color: #a8d1fe;
        }
      }
    }
  }
}
</style>